export const ProtectUserMenuId = "protect-user-menu";

// Modules ideally register their own items without knowing about each other, but having priorities scattered
// across each module makes it hard to figure out the overall order. Centralizing them here makes that easier.
export const ProtectUserMenuItemPriority = {
    Account: 200,
    Subscription: 100
} as const;
